import { Icon } from '@vrplatform/icons';
import { IconButton } from '@vrplatform/components-legacy';

type Props = {
  onClick: () => void;
  disabled?: boolean;
};

export const ActivityButton = (props: Props) => {
  'use-memo';

  return (
    <IconButton aria-label="View activity" {...props}>
      <Icon icon="HistoryIcon" size={16} />
    </IconButton>
  );
};
